import { api, helpers, mui, React, ts, ui } from '_core';

type LayoutRenameProps = {
  selectedPreference?: ts.types.userPreference.UserPreference;
  setSelectedPreference: (_v: ts.types.userPreference.UserPreference) => void;
  preferences: ts.types.userPreference.UserPreference[];
  setPreferences: (_v: ts.types.userPreference.UserPreference[]) => void;
  open: boolean;
  setOpen: (_v: boolean) => void;
};

const LayoutRename = ({
  selectedPreference,
  setSelectedPreference,
  preferences,
  setPreferences,
  open,
  setOpen,
}: LayoutRenameProps) => {
  const [errorMessage, setErrorMessage] = React.useState('');
  const [title, setTitle] = React.useState(selectedPreference.title);
  const [loadingRename, setLoadingRename] = React.useState(false);

  React.useEffect(() => {
    setTitle(selectedPreference.title);
  }, [selectedPreference, preferences]);

  const handleRename = async () => {
    setErrorMessage('');

    // Validation
    if (!title) {
      setErrorMessage('Name is a required field.');
      setLoadingRename(false);
      return;
    }

    setLoadingRename(true);
    try {
      const resp = await api.user_preferences.update(selectedPreference.id, {
        title,
      });

      setPreferences(
        preferences.map((p) => {
          if (p.id == selectedPreference.id) return resp.data;
          return p;
        })
      );

      setSelectedPreference(resp.data);

      setLoadingRename(false);
      setOpen(false);
    } catch (err) {
      setErrorMessage(helpers.parseApiError(err as any));
      setLoadingRename(false);
    }
  };

  return (
    <mui.core.Dialog
      open={open}
      onClose={() => setOpen(false)}
      aria-labelledby="alert-dialog-title"
      aria-describedby="alert-dialog-description"
      maxWidth="sm"
      fullWidth
    >
      {errorMessage && (
        <mui.core.Alert onClose={() => setErrorMessage('')} severity="error">
          {errorMessage}
        </mui.core.Alert>
      )}

      <ui.DialogTitle closeAction={() => setOpen(false)}>Rename View</ui.DialogTitle>

      <mui.core.DialogContent>
        <mui.core.Box py={2}>
          <mui.core.TextField
            id="Name"
            label={'Name'}
            value={title}
            onChange={(e) => setTitle(e.target.value)}
            fullWidth
            variant="outlined"
            required
            size="small"
          />
        </mui.core.Box>
      </mui.core.DialogContent>

      <mui.core.DialogActions>
        <ui.Button
          variant="contained"
          color="primary"
          loading={loadingRename}
          onClick={() => handleRename()}
          style={{ margin: '0rem 1rem 1rem' }}
          fullWidth
        >
          Rename
        </ui.Button>
      </mui.core.DialogActions>
    </mui.core.Dialog>
  );
};

export default LayoutRename;
